function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from 'react';
import defaultPropTypes from './prop-types';
export function renderComponents(className, elements, props) {
  var cloneProps = Object.assign({}, props);
  delete cloneProps.header;
  delete cloneProps.footer;
  return elements.length ? /*#__PURE__*/React.createElement("div", {
    className: className
  }, elements.map(function (view) {
    return /*#__PURE__*/React.cloneElement(view, Object.assign({}, view.props, cloneProps));
  })) : '';
}

/**
 * function to make clickable URL to get directions from Google.
 * Accepts both location objects with lat and lng attributes or a string value for both origin and destination.
 *
 * @param {string|object} origin
 * @param {string|object} destination
 * @returns {string}
 */
export default function makeDirectionsUrl() {
  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var destination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var baseUrl = 'https://www.google.com/maps/dir/?api=1';
  var params = '';
  if (_typeof(origin) === 'object' && Object.prototype.hasOwnProperty.call(origin, 'lat') && Object.prototype.hasOwnProperty.call(origin, 'lng')) {
    params = "".concat(params, "&origin=").concat(origin.lat, ",").concat(origin.lng);
  } else if (typeof origin === 'string' && origin !== '') {
    params = "".concat(params, "&origin=").concat(encodeURI(origin));
  }
  if (_typeof(destination) === 'object' && Object.prototype.hasOwnProperty.call(destination, 'lat') && Object.prototype.hasOwnProperty.call(destination, 'lng')) {
    params = "".concat(params, "&destination=").concat(destination.lat, ",").concat(destination.lng);
  } else if (typeof destination === 'string' && destination !== '') {
    params = "".concat(params, "&destination=").concat(encodeURI(destination));
  }
  return baseUrl + params;
}
export function withTempSelection(Component) {
  var clzz = /*#__PURE__*/function (_React$Component) {
    function WithHover(props) {
      var _this;
      _classCallCheck(this, WithHover);
      _this = _callSuper(this, WithHover, [props]);
      _this.onMouseOver = _this.onMouseOver.bind(_this);
      _this.onMouseOut = _this.onMouseOut.bind(_this);
      return _this;
    }
    _inherits(WithHover, _React$Component);
    return _createClass(WithHover, [{
      key: "onMouseOver",
      value: function onMouseOver() {
        this.props.onTempSelectLocation(this.props.location, 'select');
      }
    }, {
      key: "onMouseOut",
      value: function onMouseOut() {
        this.props.onTempSelectLocation(this.props.location, 'deselect');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement("div", {
          onMouseOver: this.onMouseOver,
          onFocus: this.onMouseOver,
          onMouseOut: this.onMouseOut,
          onBlur: this.onMouseOut
        }, /*#__PURE__*/React.createElement(Component, this.props));
      }
    }]);
  }(React.Component);
  clzz.propTypes = {
    onTempSelectLocation: defaultPropTypes.func.isRequired,
    location: defaultPropTypes.location.isRequired
  };
  return clzz;
}